<nav
  class="h-16 p-8 capitalize bg-white shadow-lg flex items-center justify-between"
>
  <div class="flex items-center gap-2">
    <span class="text-2xl"> Employee management system </span>

    @if (isAdmin()) {
      <span
        class="px-2 py-0.5 text-xs font-bold rounded-md bg-blue-100 text-blue-700 border border-blue-500"
      >
        ADMIN
      </span>
    }
  </div>

  @if (isAuthenticated()) {
    <button
      type="button"
      class="px-4 py-2 rounded-md text-white font-semibold bg-red-600 hover:bg-red-700 hover: cursor-pointer transition-colors duration-200"
      (click)="logout()"
    >
      Logout
    </button>
  }
</nav>
